import { apiSlice } from "./apiSlice";

export const mastersVariantMutationsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 🔧 Add Variant Mutation
    addVariant: builder.mutation({
      query: (payload) => {
        const { category, ...body } = payload;
        return {
          url: `masters/${category}`,
          method: "POST",
          body,
        };
      },
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const { category, brand, model } = payload;
        try {
          const { data } = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              "getMastersVariantList",
              { category, brand, model },
              (draft) => {
                if (data?.id) draft.entities[data.id] = data;
              }
            )
          );
        } catch (err) {
          console.error("Add variant failed:", err);
        }
      },
      invalidatesTags: (result, error, { category }) => [
        { type: `mastersvariant${category}` },
      ],
    }),

    // ✏️ Update Variant Mutation
    updateVariant: builder.mutation({
      query: (payload) => {
        const { category, ...body } = payload;
        return {
          url: `masters/${category}`,
          method: "PUT",
          body,
        };
      },
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const { id, category, brand, model, ...updatedFields } = payload;
        // Optimistically update
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getMastersVariantList",
            { category, brand, model },
            (draft) => {
              if (draft.entities[id]) {
                Object.assign(draft.entities[id], updatedFields);
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo(); // Rollback if failed
          console.error("Update variant failed:", err);
        }
      },
      invalidatesTags: (result, error, { id, category }) => [
        { type: `mastersvariant${category}`, id },
      ],
    }),

    // ❌ Delete Variant Mutation
    deleteVariant: builder.mutation({
      query: ({ id, category }) => ({
        url: `masters/${category}?id=${id}`,
        method: "DELETE",
      }),
      async onQueryStarted({ id, category, brand, model }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getMastersVariantList",
            { category, brand, model },
            (draft) => {
              delete draft.entities[id];
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo(); // Rollback
          console.error("Delete variant failed:", err);
        }
      },
      invalidatesTags: (result, error, { id, category }) => [
        { type: `mastersvariant${category}`, id },
      ],
    }),
  }),
});

export const {
  useAddVariantMutation,
  useUpdateVariantMutation,
  useDeleteVariantMutation,
} = mastersVariantMutationsSlice;
